/**
 * SiteUp: máscara BRL para campos de valor do Kanban.
 * Digitação por centavos (ex.: 100000 → R$ 1.000,00).
 */

export const formatKanbanCurrency = (
  value,
  currency = { code: 'BRL', locale: 'pt-BR' }
) => {
  if (value === null || value === undefined || value === '') return '';
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return '';
  const code = currency?.code || 'BRL';
  const locale = currency?.locale || 'pt-BR';
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(numeric);
  } catch (e) {
    return String(value);
  }
};

/** Converte string mascarada / livre em número (BRL). */
export const parseKanbanCurrencyInput = raw => {
  if (raw === null || raw === undefined || String(raw).trim() === '') {
    return null;
  }
  const str = String(raw).trim();
  // Só dígitos → interpreta como centavos (máscara progressiva)
  if (/^[\d\s.R$]*\d[\d\s.]*$/.test(str.replace(/R\$\s?/g, '')) && str.includes(',')) {
    const normalized = str
      .replace(/[^\d,]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');
    const n = Number(normalized);
    return Number.isFinite(n) ? n : null;
  }
  const digits = str.replace(/\D/g, '');
  if (!digits) return null;
  // Se veio só dígitos da máscara progressiva
  if (!str.includes(',') && !str.includes('.')) {
    return Number(digits) / 100;
  }
  const normalized = str
    .replace(/[^\d,.-]/g, '')
    .replace(/\./g, '')
    .replace(',', '.');
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
};

/**
 * Aplica máscara BRL enquanto digita (centavos).
 * Retorna string formatada tipo "R$ 1.234,56".
 */
export const maskKanbanCurrencyTyping = raw => {
  const digits = String(raw ?? '').replace(/\D/g, '');
  if (!digits) return '';
  const cents = Number(digits) / 100;
  return formatKanbanCurrency(cents);
};

/** Handler @input para inputs de valor — atualiza o draft mascarado. */
export const onKanbanCurrencyInput = (event, setDraft) => {
  const masked = maskKanbanCurrencyTyping(event?.target?.value);
  setDraft(masked);
  if (event?.target) {
    event.target.value = masked;
  }
};
